import script from "./DownloadLimitIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadLimitIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadLimitIndicator.vue?vue&type=style&index=0&id=4db4e7a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db4e7a5"]])

export default __exports__